module.exports = __webpack_public_path__ + "img/brillante_11.aad9b3fa.svg";